export default __webpack_public_path__ + "static/media/dropdownProfile.097f170a.svg";